import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled$1 from 'styled-components';
import { space, colors, border } from 'nicollet-tokens';

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ::before {\n    display: block;\n    content: '';\n    width: 12px;\n    height: 12px;\n    background: ", ";\n    margin: 0;\n    list-style: none;\n    border-radius: ", ";\n    transform: ", ";\n    opacity: ", ";\n    transition: all 200ms ease-out;\n  }\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0;\n  margin: 0;\n  min-width: 20px;\n  height: 20px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 0;\n  margin: 0;\n  ", ";\n  transition: transform 200ms ease-out;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 140px;\n  height: 20px;\n  overflow: hidden;\n  margin: 0 auto;\n  padding: ", " 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var transformDotSize = function transformDotSize(_ref) {
  var active = _ref.active,
      activeNeighbor = _ref.activeNeighbor;
  if (active) return 'scale(1)';
  if (activeNeighbor) return 'scale(.75)';
  return 'scale(.5)';
};

var PaginationDotsWrapper = styled$1.div(_templateObject(), space.generic.x5);
var StyledUnorderedList = styled$1.ul(_templateObject2(), function (_ref2) {
  var translate = _ref2.translate;
  return translate && "transform: translate(".concat(translate, "px)");
});
var StyledListItem = styled$1.li(_templateObject3(), colors.palette.gray.darkest, border.radius.circle, transformDotSize, function (_ref3) {
  var active = _ref3.active;
  return active ? 1 : 0.3;
});

export { PaginationDotsWrapper, StyledListItem, StyledUnorderedList };
